// extracted by mini-css-extract-plugin
export default {"spaced":"styles_spaced__KG52D","text":"styles_text__So+ow","contain":"styles_contain__8oAX+","icon":"styles_icon__oI1o3","hideDropdown":"styles_hideDropdown__daR24"};